/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class ParameterData {
  name: string;
  comparison: string;
  value: string;
}
